import e, { Component as t, Fragment as o } from "react";
import r from "prop-types";
import n, { keyframes as i } from "styled-components";
import a from "webfontloader";

function l(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function c(e, t) {
  for (var o = 0; o < t.length; o++) {
    var r = t[o];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function s(e, t, o) {
  return t && c(e.prototype, t), o && c(e, o), e;
}

function d(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}

function f() {
  return (f = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function u(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && p(e, t);
}

function m(e) {
  return (m = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function p(e, t) {
  return (p = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function g(e, t) {
  if (null == e) return {};

  var o,
      r,
      n = function (e, t) {
    if (null == e) return {};
    var o,
        r,
        n = {},
        i = Object.keys(e);

    for (r = 0; r < i.length; r++) {
      o = i[r], t.indexOf(o) >= 0 || (n[o] = e[o]);
    }

    return n;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (r = 0; r < i.length; r++) {
      o = i[r], t.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
  }

  return n;
}

function h(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function b(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? h(e) : t;
}

var y = 16,
    w = function w(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    v = function v() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var o = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var r = w(o);
    "rem" !== r.units ? e += r.number / y : e += r.number, 0 != r.number && (e += "rem");
  }

  return e;
};

function k() {
  var e = function (e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }([""]);

  return k = function k() {
    return e;
  }, e;
}

function S(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}

function x(e, t) {
  var o = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), o.push.apply(o, r);
  }

  return o;
}

function C(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = null != arguments[t] ? arguments[t] : {};
    t % 2 ? x(o, !0).forEach(function (t) {
      S(e, t, o[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : x(o).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
    });
  }

  return e;
}

var O = function O(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    E = function E() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var o = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var r = O(o);
    "rem" !== r.units ? e += r.number / 16 : e += r.number, 0 != r.number && (e += "rem");
  }

  return e;
},
    F = {
  black: "#000000",
  white: "#ffffff",
  red: "#d52b1e",
  charcoal: "#454545",
  green: "#00ac3e",
  blue: "#0088ce",
  yellow: "#ffbc3d",
  orange: "#ed7000",
  coolGray1: "#f6f6f6",
  coolGray3: "#d8dada",
  coolGray6: "#747676",
  coolGray10: "#333333",
  grayLight: "#d8dada"
},
    z = C({}, F, {}, {
  textColor: F.charcoal,
  textColorSuccess: F.white,
  textColorInfo: F.white,
  textColorWarning: F.charcoal,
  textColorError: F.white
}),
    H = {
  fontFamily: '"BrandFont-Text", Helvetica, Arial, sans-serif',
  monospace: '"SFMono-Regular", "RobotoMono-Regular", monospace',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  serif: "serif",
  iconFontUrl: "https://respframework.verizon.com/fonts/verizon-icons/fonts.css",
  iconFont: "verizon-icons"
},
    j = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
},
    P = C({}, H, {}, {
  fontColor: z.black,
  fontColorAlt: z.white,
  fontSize: E(16)
}, {
  fontWeights: j,
  fontHeader: H.fontFamily,
  fontBody: H.sans,
  fontWeight: j
}),
    D = C({
  name: "Verizon Theme"
}, z, {}, P, {}, {
  primary: z.black,
  secondary: z.white,
  accent: z.red,
  background: z.white,
  backgroundColorDisabled: z.coolGray3,
  success: z.green,
  info: z.blue,
  warning: z.yellow,
  error: z.orange,
  disabled: z.coolGray3,
  textColorSuccess: z.white,
  textColorInfo: z.white,
  textColorWarning: z.black,
  textColorError: z.black,
  textColorDisabled: z.white,
  borderWidth: E(1),
  borderStyle: "solid",
  borderColor: z.coolGray3,
  border: "".concat(E(1), " solid ").concat(z.coolGray3),
  borderColorDisabled: z.coolGray3,
  linkColor: z.black,
  linkColorHover: z.blue,
  linkColorActive: z.blue,
  linkDecoration: "underline",
  transitionDuration: "0.2s",
  hrPrimary: "".concat(E(4), " solid ").concat(z.charcoal),
  hrSecondary: "".concat(E(1), " solid ").concat(z.charcoal),
  hrTertiary: "".concat(E(1), " solid ").concat(z.coolGray3)
}),
    W = {
  typestack: "MVP"
},
    I = function I(e) {
  return W.typestack;
};

a.load({
  custom: {
    families: ["BrandFont-Text", "BrandFont-Display"],
    urls: ["https://respframework.verizon.com/fonts/v2/fonts.css"]
  }
});

var M = "BrandFont-Text",
    T = "BrandFont-Display",
    _ = {
  VDS: {
    mobile: {
      extraExtraLarge: {
        fontSize: 32,
        lineHeight: 32,
        fontWeight: "bold",
        fontFamily: M
      },
      extraLarge: {
        fontSize: 32,
        lineHeight: 32,
        fontWeight: "bold",
        fontFamily: M
      },
      large: {
        fontSize: 24,
        lineHeight: 24,
        fontWeight: "bold",
        fontFamily: M
      },
      medium: {
        fontSize: 20,
        lineHeight: 20,
        fontWeight: "bold",
        fontFamily: M
      },
      small: {
        fontSize: 16,
        lineHeight: 16,
        fontWeight: "bold",
        fontFamily: M
      },
      extraSmall: {
        fontSize: 12,
        lineHeight: 11,
        fontWeight: "bold",
        fontFamily: M
      }
    },
    desktop: {
      extraExtraLarge: {
        fontSize: 64,
        lineHeight: 64,
        fontWeight: "bold",
        fontFamily: M
      },
      extraLarge: {
        fontSize: 48,
        lineHeight: 48,
        fontWeight: "bold",
        fontFamily: M
      },
      large: {
        fontSize: 32,
        lineHeight: 32,
        fontWeight: "bold",
        fontFamily: M
      },
      medium: {
        fontSize: 24,
        lineHeight: 24,
        fontWeight: "bold",
        fontFamily: M
      },
      small: {
        fontSize: 20,
        lineHeight: 20,
        fontWeight: "bold",
        fontFamily: M
      },
      extraSmall: {
        fontSize: 14,
        lineHeight: 14.5,
        fontWeight: "bold",
        fontFamily: M
      }
    }
  },
  MVP: {
    mobile: {
      extraExtraLarge: {
        fontSize: 34,
        lineHeight: 32.3,
        fontWeight: "750",
        fontFamily: T
      },
      extraLarge: {
        fontSize: 34,
        lineHeight: 32.3,
        fontWeight: "750",
        fontFamily: T
      },
      large: {
        fontSize: 25,
        lineHeight: 24,
        fontWeight: "750",
        fontFamily: T
      },
      medium: {
        fontSize: 16,
        lineHeight: 15,
        fontWeight: "750",
        fontFamily: T
      },
      small: {
        fontSize: 16,
        lineHeight: 15,
        fontWeight: "750",
        fontFamily: T
      },
      extraSmall: {
        fontSize: 12,
        lineHeight: 11,
        fontWeight: "750",
        fontFamily: T
      }
    },
    desktop: {
      extraExtraLarge: {
        fontSize: 64,
        lineHeight: 60.8,
        fontWeight: "750",
        fontFamily: T
      },
      extraLarge: {
        fontSize: 44,
        lineHeight: 41.8,
        fontWeight: "750",
        fontFamily: T
      },
      large: {
        fontSize: 32,
        lineHeight: 30.4,
        fontWeight: "750",
        fontFamily: T
      },
      medium: {
        fontSize: 24,
        lineHeight: 22.8,
        fontWeight: "750",
        fontFamily: T
      },
      small: {
        fontSize: 20,
        lineHeight: 19,
        fontWeight: "750",
        fontFamily: T
      },
      extraSmall: {
        fontSize: 14,
        lineHeight: 14.5,
        fontWeight: "750",
        fontFamily: T
      }
    }
  },
  getStyles: function getStyles(e, t, o) {
    return _[e][t][o];
  }
},
    G = ["#000000", "#FFFFFF", "#ffffff", "#F6F6F6", "#f6f6f6", "#D8DADA", "#d8dada", "#747676", "#333333", "#0088CE", "#0088ce"],
    L = function (e) {
  function t(t, o, r, n) {
    return n = n || "ANONYMOUS", null == o[r] ? t ? console.warn("Required ".concat(r, " was not specified in ").concat(n)) : null : e(o, r, n);
  }

  var o = t.bind(null, !1);
  return o.isRequired = t.bind(null, !0), o;
}(function (e, t, o) {
  var r;
  return e && e[t] && !((r = e[t]) ? G.indexOf(r) > -1 : console.error("Need a color passed through")) ? console.warn("The color, ".concat(e[t], " is not a defined prop for ").concat(o, " ")) : null;
});

function B() {
  return (B = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function A(e, t) {
  if (null == e) return {};

  var o,
      r,
      n = function (e, t) {
    if (null == e) return {};
    var o,
        r,
        n = {},
        i = Object.keys(e);

    for (r = 0; r < i.length; r++) {
      o = i[r], t.indexOf(o) >= 0 || (n[o] = e[o]);
    }

    return n;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (r = 0; r < i.length; r++) {
      o = i[r], t.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
  }

  return n;
}

var V = function V(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    R = function R() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var o = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var r = V(o);
    "rem" !== r.units ? e += r.number / 16 : e += r.number, 0 != r.number && (e += "rem");
  }

  return e;
},
    N = {
  primitive: r.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "p", "a", "span"]),
  children: r.node
},
    Z = n(function (t) {
  var o = t.primitive,
      r = t.children,
      n = A(t, ["primitive", "children"]);
  return e.createElement(o, n, r);
}).withConfig({
  displayName: "Typography__StyledTypography",
  componentId: "c213tb-0"
})(["font-size:", ";font-weight:", ";line-height:", ";font-family:", ";color:", ";margin:0;text-decoration:none;"], function (e) {
  var t = e.fontSize;
  return R(t);
}, function (e) {
  return e.fontWeight;
}, function (e) {
  var t = e.lineheight;
  return R(t);
}, function (e) {
  return e.fontFamily;
}, function (e) {
  return e.color;
}),
    U = function U(t) {
  var o = t.children,
      r = t.primitive,
      n = A(t, ["children", "primitive"]);
  return e.createElement(Z, B({}, n, {
    primitive: r
  }), o);
};

U.propTypes = N, U.defaultProps = {
  children: null,
  primitive: "p"
};
r.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "a", "span", "p"]), r.oneOf(["desktop", "mobile", "tablet"]), r.oneOf(["extraSmall", "small", "medium", "large", "extraLarge", "extraExtraLarge"]), r.node, r.bool, r.oneOf(["VDS", "MVP"]), r.object, r.number, D.black, n(U).withConfig({
  displayName: "Title__StyledTitle",
  componentId: "sc-1j7ori5-0"
})(["&:active,&:hover{outline:none;}"]), r.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "a", "span", "p"]), r.oneOf(["desktop", "tablet", "mobile"]), r.node, r.oneOf(["VDS", "MVP"]), r.object, r.number, D.black, n(U).withConfig({
  displayName: "Subtitle__StyledSubtitle",
  componentId: "sc-98ihf2-0"
})(["&:active,&:hover{outline:none;}"]);

var q = {
  VDS: {
    mobile: {
      large: {
        fontSize: 16,
        lineHeight: 20,
        fontFamily: M
      },
      medium: {
        fontSize: 16,
        lineHeight: 20,
        fontFamily: M
      },
      small: {
        fontSize: 12,
        lineHeight: 16,
        fontFamily: M
      }
    },
    desktop: {
      large: {
        fontSize: 16,
        lineHeight: 20,
        fontFamily: M
      },
      medium: {
        fontSize: 16,
        lineHeight: 20,
        fontFamily: M
      },
      small: {
        fontSize: 12,
        lineHeight: 16,
        fontFamily: M
      }
    }
  },
  MVP: {
    mobile: {
      large: {
        fontSize: 12,
        lineHeight: 14.4,
        fontFamily: M
      },
      medium: {
        fontSize: 12,
        lineHeight: 14.4,
        fontFamily: M
      },
      small: {
        fontSize: 12,
        lineHeight: 14.4,
        fontFamily: M
      }
    },
    desktop: {
      large: {
        fontSize: 16,
        lineHeight: 19.2,
        fontFamily: M
      },
      medium: {
        fontSize: 14,
        lineHeight: 16.8,
        fontFamily: M
      },
      small: {
        fontSize: 12,
        lineHeight: 14.4,
        fontFamily: M
      }
    }
  },
  getStyles: function getStyles(e, t, o) {
    return q[e][t][o];
  }
},
    K = (r.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "a", "span", "p"]), r.oneOf(["desktop", "tablet", "mobile"]), r.oneOf(["small", "medium", "large"]), r.node, r.bool, r.oneOf(["VDS", "MVP"]), r.object, r.number, D.black, n(U).withConfig({
  displayName: "Body__StyledBody",
  componentId: "qpp2ii-0"
})(["&:active,&:hover{outline:none;}"]), {
  VDS: {
    mobile: {
      fontSize: 11,
      lineHeight: 16,
      fontWeight: "normal",
      fontFamily: M
    },
    desktop: {
      fontSize: 11,
      lineHeight: 16,
      fontWeight: "normal",
      fontFamily: M
    }
  },
  MVP: {
    mobile: {
      fontSize: 10,
      lineHeight: 12,
      fontWeight: "400",
      fontFamily: M
    },
    desktop: {
      fontSize: 10,
      lineHeight: 12,
      fontWeight: "400",
      fontFamily: M
    }
  },
  getStyles: function getStyles(e, t) {
    return K[e][t];
  }
}),
    Y = {
  primitive: r.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "a", "span", "p"]),
  viewport: r.oneOf(["desktop", "mobile", "tablet"]),
  children: r.node,
  color: L,
  typestack: r.oneOf(["VDS", "MVP"]),
  theme: r.object,
  tabIndex: r.number
},
    J = {
  primitive: "p",
  viewport: "desktop",
  children: null,
  color: D.black,
  tabIndex: 0
},
    Q = n(U).withConfig({
  displayName: "Micro__StyledMicro",
  componentId: "zo9y8f-0"
})(["&:active,&:hover{outline:none;}"]),
    X = function X(t) {
  var o = t.children,
      r = t.primitive,
      n = t.viewport,
      i = t.color,
      a = t.typestack,
      l = t.theme,
      c = t.tabIndex,
      s = a || (l && l.typestack ? l.typestack : I()),
      d = "mobile" === n ? "mobile" : "desktop",
      f = K[s][d];
  return e.createElement(Q, {
    fontSize: f.fontSize,
    fontWeight: f.fontWeight,
    fontFamily: f.fontFamily,
    lineheight: f.lineHeight,
    primitive: r,
    color: i,
    tabIndex: c,
    "aria-hidden": c < 0,
    onClick: function onClick(e) {
      "click" === e.type && e.currentTarget.blur();
    }
  }, o);
};

function $(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}

function ee(e, t) {
  var o = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), o.push.apply(o, r);
  }

  return o;
}

function te(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ee(o, !0).forEach(function (t) {
      $(e, t, o[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ee(o).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
    });
  }

  return e;
}

X.propTypes = Y, X.defaultProps = J;

var oe = function oe(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    re = function re() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var o = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var r = oe(o);
    "rem" !== r.units ? e += r.number / 16 : e += r.number, 0 != r.number && (e += "rem");
  }

  return e;
},
    ne = {
  black: "#000000",
  white: "#ffffff",
  red: "#d52b1e",
  charcoal: "#454545",
  green: "#00ac3e",
  blue: "#0088ce",
  yellow: "#ffbc3d",
  orange: "#ed7000",
  coolGray1: "#f6f6f6",
  coolGray3: "#d8dada",
  coolGray6: "#747676",
  coolGray10: "#333333",
  grayLight: "#d8dada"
},
    ie = te({}, ne, {}, {
  textColor: ne.charcoal,
  textColorSuccess: ne.white,
  textColorInfo: ne.white,
  textColorWarning: ne.charcoal,
  textColorError: ne.white
}),
    ae = {
  fontFamily: '"BrandFont-Text", Helvetica, Arial, sans-serif',
  monospace: '"SFMono-Regular", "RobotoMono-Regular", monospace',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  serif: "serif",
  iconFontUrl: "https://respframework.verizon.com/fonts/verizon-icons/fonts.css",
  iconFont: "verizon-icons"
},
    le = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
},
    ce = te({}, ae, {}, {
  fontColor: ie.black,
  fontColorAlt: ie.white,
  fontSize: re(16)
}, {
  fontWeights: le,
  fontHeader: ae.fontFamily,
  fontBody: ae.sans,
  fontWeight: le
}),
    se = te({
  name: "Verizon Theme"
}, ie, {}, ce, {}, {
  primary: ie.black,
  secondary: ie.white,
  accent: ie.red,
  background: ie.white,
  backgroundColorDisabled: ie.coolGray3,
  success: ie.green,
  info: ie.blue,
  warning: ie.yellow,
  error: ie.orange,
  disabled: ie.coolGray3,
  textColorSuccess: ie.white,
  textColorInfo: ie.white,
  textColorWarning: ie.black,
  textColorError: ie.black,
  textColorDisabled: ie.white,
  borderWidth: re(1),
  borderStyle: "solid",
  borderColor: ie.coolGray3,
  border: "".concat(re(1), " solid ").concat(ie.coolGray3),
  borderColorDisabled: ie.coolGray3,
  linkColor: ie.black,
  linkColorHover: ie.blue,
  linkColorActive: ie.blue,
  linkDecoration: "underline",
  transitionDuration: "0.2s",
  hrPrimary: "".concat(re(4), " solid ").concat(ie.charcoal),
  hrSecondary: "".concat(re(1), " solid ").concat(ie.charcoal),
  hrTertiary: "".concat(re(1), " solid ").concat(ie.coolGray3)
}),
    de = I(),
    fe = _.getStyles(de, "desktop", "large"),
    ue = _.getStyles(de, "mobile", "large"),
    me = q.getStyles(de, "desktop", "medium"),
    pe = q.getStyles(de, "desktop", "small"),
    ge = ["small", "medium", "normal", "large"],
    he = {
  setTriggerRef: r.func,
  theme: r.object
},
    be = {
  setTriggerRef: function setTriggerRef() {},
  theme: se
},
    ye = n.button.withConfig({
  displayName: "DropdownSelectMarketingTrigger__Trigger",
  componentId: "sc-1q2dmnl-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;background:", ";border-bottom:", ";border-top:0;border-right:0;border-left:0;padding-right:0;padding-top:0;padding-left:0;color:", ";cursor:", ";position:relative;transition:border 300ms;transition:color 300ms;min-width:", ";width:", ";overflow:hidden;text-overflow:ellipsis;z-index:1;white-space:nowrap;&.focus-visible{background:white;color:", ";transition:color 300ms;}", ";", " &:active,&:hover{outline:none;}*{outline:none;}"], se.white, function (e) {
  var t = e.error,
      o = e.disabled,
      r = t ? se.error : o ? se.coolGray3 : se.black,
      n = v(t ? 4 : 1);
  return "".concat(n, " solid ").concat(r);
}, function (e) {
  return e.disabled ? e.theme.coolGray3 : e.theme.coolGray6;
}, function (e) {
  return e.disabled ? "default" : "pointer";
}, function (e) {
  var t = e.size;
  return ge.includes(t) ? v(146) : null;
}, function (e) {
  return e.width;
}, se.black, function (e) {
  return function (e) {
    var t, o;

    switch (e) {
      case "large":
        o = fe, t = 38;
        break;

      case "medium":
        o = me, t = 23;
        break;

      case "normal":
        o = fe, t = 38;
        break;

      case "small":
        o = pe, t = 22;
        break;

      case "desktopLarge":
        o = fe, t = 33;
        break;

      case "mobileLarge":
        o = ue, t = 27;
        break;

      case "mobileSmall":
        o = pe, t = 17;
        break;

      case "desktopSmall":
      default:
        t = 20, o = me;
    }

    return "\n    height: ".concat(v(t), ";\n    font-size: ").concat(v(o.fontSize), ";\n    line-height: ").concat(v(o.lineHeight), ";\n    font-family: ").concat(o.fontFamily, ";\n    font-weight: ").concat("bold", ";\n  ");
  }(e.size);
}, function (e) {
  var t = e.disabled,
      o = e.theme;
  return !t && "\n      &:hover {\n        transition: color 300ms;\n        color: ".concat(o.black, ";\n      }\n  ");
}),
    we = function (o) {
  function r() {
    var e, t;
    l(this, r);

    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++) {
      i[a] = arguments[a];
    }

    return d(h(t = b(this, (e = m(r)).call.apply(e, [this].concat(i)))), "componentDidMount", function () {
      t.props.setTriggerRef(t.triggerElem);
    }), d(h(t), "refKey", "function" == typeof n.div(k()).extend ? "innerRef" : "ref"), t;
  }

  return u(r, t), s(r, [{
    key: "render",
    value: function value() {
      var t = this;
      return e.createElement(ye, f({}, this.props, d({}, this.refKey, function (e) {
        return t.triggerElem = e;
      })));
    }
  }]), r;
}();

we.defaultProps = be, we.propTypes = he;

var ve = I(),
    ke = _.getStyles(ve, "desktop", "large"),
    Se = _.getStyles(ve, "mobile", "large"),
    xe = q.getStyles(ve, "desktop", "medium"),
    Ce = q.getStyles(ve, "desktop", "small"),
    Oe = i(["0%{opacity:0;transform:translateY(-10px);}100%{opacity:1;transform:translateY(0);}"]),
    Ee = n.div.withConfig({
  displayName: "DropdownSelectMarketingList__List",
  componentId: "iaf5ct-0"
})([".slide-down[data-menu-list]{}> [data-menu]{font-family:", ";display:block;}&[data-menu-list]{animation:", " 0.2s ease;background:", ";border:", " solid ", ";border-top:1px solid transparent;overflow:hidden;padding-bottom:0;padding-top:0;top:100%;transition:border 400ms,height 350ms;width:", ";}> [data-menu-item]{background:none;border-top:none;border-right:none;border-bottom:1px solid ", ";border-left:none;color:", ";cursor:pointer;margin:0;text-align:left;text-decoration:none;", ";&:hover,&:focus{background:", ";color:", ";transition:color 300ms;}&:last-of-type{border-bottom:", " solid transparent;}}> [data-menu-item][data-selected]{background:", ";color:", ";transition:color 300ms;}"], se.fontFamily, Oe, se.white, v(1), se.coolGray3, function (e) {
  var t = e.triggerElem;
  return "".concat(v(t.getBoundingClientRect().width - 2));
}, se.coolGray3, se.coolGray6, function (e) {
  return function (e) {
    var t, o;

    switch (e) {
      case "large":
      case "normal":
        t = ke, o = v(12, 12, 12.6, 12);
        break;

      case "medium":
        t = xe, o = v(12, 14, 12.2, 14);
        break;

      case "small":
        t = Ce, o = v(12, 14, 12.6, 14);
        break;

      case "desktopLarge":
        t = ke, o = v(13, 12, 12.6, 12);
        break;

      case "mobileLarge":
        t = Se, o = v(16, 12, 16, 12);
        break;

      case "mobileSmall":
        t = Ce, o = v(14, 14, 13.6, 14);
        break;

      case "desktopSmall":
      default:
        t = xe, o = v(13, 14, 12.2, 14);
    }

    return "\n    font-size: ".concat(v(t.fontSize), ";\n    font-family: ").concat(t.fontFamily, ";\n    font-weight: ").concat("bold", ";\n    line-height: ").concat(v(t.lineHeight), ";\n    padding: ").concat(o, ";\n  ");
  }(e.size);
}, se.white, se.black, v(1), se.white, se.black),
    Fe = function Fe(t) {
  return e.createElement(Ee, f({
    "data-menu-list": !0
  }, t));
},
    ze = {
  "arrow-left": {
    viewBox: "0 0 24 24",
    path: ["M11.81,22,2.16,12.09,11.81,2,13,3.11,5.16,11.28H21.84v1.6H5.18l7.78,8Z"]
  },
  "arrow-right": {
    viewBox: "0 0 24 24",
    path: ["M12.19,22l9.65-9.91L12.19,2,11,3.11l7.81,8.17H2.16v1.6H18.82l-7.78,8Z"]
  },
  calendar: {
    viewBox: "0 0 24 24",
    path: ["M9.79,18.55a3.86,3.86,0,0,1-1.85-.45,3.72,3.72,0,0,1-1.78-3.38H7.59a2.45,2.45,0,0,0,1,2.13,2.82,2.82,0,0,0,2.67-.14,1.57,1.57,0,0,0,.78-1.45,1.55,1.55,0,0,0-.9-1.2,4.54,4.54,0,0,0-1.64-.28l-.65,0,0-1.42A5.68,5.68,0,0,0,10.82,12a1.23,1.23,0,0,0,.76-.93,1.48,1.48,0,0,0-1.22-1.39,2.09,2.09,0,0,0-2.53,1,2.36,2.36,0,0,0-.11.87H6.29a3.54,3.54,0,0,1,.21-1.4,3.51,3.51,0,0,1,4.24-1.83A2.84,2.84,0,0,1,13,11.14a2.43,2.43,0,0,1-1,1.76,2.83,2.83,0,0,1,1.48,2.26,3,3,0,0,1-1.44,2.75A4.19,4.19,0,0,1,9.79,18.55Zm8-10.09H16.32v0a1.8,1.8,0,0,1-.46,1.33,2,2,0,0,1-1.25.47h-.17v1.43h1.88v6.49h1.43ZM22,2H2V22H22ZM3.43,6.08H20.57V20.57H3.43Zm0-2.65H20.57V4.66H3.43Z"]
  },
  "caret-down": {
    viewBox: "0 0 24 24",
    path: ["M12,17.79,2,7.64,3.41,6.21,12,14.93l8.56-8.65L22,7.7Z"]
  },
  "caret-left-bold": {
    viewBox: "0 0 24 24",
    path: ["M15.85,22l-10-10L15.91,2l2.23,2.23L10.33,12l7.75,7.74Z"]
  },
  "caret-left": {
    viewBox: "0 0 24 24",
    path: ["M16.18,22l-10-10,10-10,1.55,1.54L9.3,12l8.43,8.43Z"]
  },
  "caret-right-bold": {
    viewBox: "0 0 24 24",
    path: ["M8.15,22l10-10L8.09,2,5.86,4.23,13.67,12,5.92,19.77Z"]
  },
  "caret-right": {
    viewBox: "0 0 24 24",
    path: ["M7.82,22,6.27,20.46,14.7,12,6.21,3.54,7.76,2l10,10Z"]
  },
  checkmark: {
    viewBox: "0 0 24 24",
    path: ["M8.94,19.23,2,12.29l1.41-1.4,5.53,5.53L20.59,4.77,22,6.18Z"]
  },
  close: {
    viewBox: "0 0 24 24",
    path: ["M13,12l9,9-1,1-9-9L3,22,2,21l9-9L2,3,3,2l9,9,9-9,1,1Z"]
  },
  collapse: {
    viewBox: "0 0 24 24",
    path: ["M22,13.5H2v-3H22Z"]
  },
  expand: {
    viewBox: "0 0 24 24",
    path: ["M22,13.43H13.43V22H10.57V13.43H2V10.57h8.57V2h2.86v8.57H22Z"]
  },
  "info-white": {
    viewBox: "0 0 24 24",
    path: ["M12,23C5.9,23,1,18.1,1,12C1,5.9,5.9,1,12,1c6.1,0,11,4.9,11,11C23,18.1,18.1,23,12,23z M12,2.6\n\t\t\tc-5.2,0-9.4,4.2-9.4,9.4c0,5.2,4.2,9.4,9.4,9.4c5.2,0,9.4-4.2,9.4-9.4C21.4,6.8,17.2,2.6,12,2.6z"],
    rect: [{
      x: "10.7",
      y: "10.8",
      class: "st0",
      width: "2.5",
      height: "8.2"
    }, {
      x: "10.7",
      y: "5.8",
      class: "st0",
      width: "2.5",
      height: "2.2"
    }]
  },
  info: {
    viewBox: "0 0 24 24",
    path: ["M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM12,3.43A8.57,8.57,0,1,0,20.57,12,8.59,8.59,0,0,0,12,3.43Zm1.2,7.4H10.8v7.89h2.4Zm0-4.78H10.8V8.16h2.4Z"]
  }
},
    He = function He(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    je = function je() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var o = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var r = He(o);
    "rem" !== r.units ? e += r.number / 16 : e += r.number, 0 != r.number && (e += "rem");
  }

  return e;
};

function Pe(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}

function De(e, t) {
  var o = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), o.push.apply(o, r);
  }

  return o;
}

function We(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = null != arguments[t] ? arguments[t] : {};
    t % 2 ? De(o, !0).forEach(function (t) {
      Pe(e, t, o[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : De(o).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
    });
  }

  return e;
}

var Ie = function Ie(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    Me = function Me() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var o = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var r = Ie(o);
    "rem" !== r.units ? e += r.number / 16 : e += r.number, 0 != r.number && (e += "rem");
  }

  return e;
},
    Te = {
  black: "#000000",
  white: "#ffffff",
  red: "#d52b1e",
  charcoal: "#454545",
  green: "#00ac3e",
  blue: "#0088ce",
  yellow: "#ffbc3d",
  orange: "#ed7000",
  coolGray1: "#f6f6f6",
  coolGray3: "#d8dada",
  coolGray6: "#747676",
  coolGray10: "#333333",
  grayLight: "#d8dada"
},
    _e = We({}, Te, {}, {
  textColor: Te.charcoal,
  textColorSuccess: Te.white,
  textColorInfo: Te.white,
  textColorWarning: Te.charcoal,
  textColorError: Te.white
}),
    Ge = {
  fontFamily: '"BrandFont-Text", Helvetica, Arial, sans-serif',
  monospace: '"SFMono-Regular", "RobotoMono-Regular", monospace',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  serif: "serif",
  iconFontUrl: "https://respframework.verizon.com/fonts/verizon-icons/fonts.css",
  iconFont: "verizon-icons"
},
    Le = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
},
    Be = We({}, Ge, {}, {
  fontColor: _e.black,
  fontColorAlt: _e.white,
  fontSize: Me(16)
}, {
  fontWeights: Le,
  fontHeader: Ge.fontFamily,
  fontBody: Ge.sans,
  fontWeight: Le
}),
    Ae = We({
  name: "Verizon Theme"
}, _e, {}, Be, {}, {
  primary: _e.black,
  secondary: _e.white,
  accent: _e.red,
  background: _e.white,
  backgroundColorDisabled: _e.coolGray3,
  success: _e.green,
  info: _e.blue,
  warning: _e.yellow,
  error: _e.orange,
  disabled: _e.coolGray3,
  textColorSuccess: _e.white,
  textColorInfo: _e.white,
  textColorWarning: _e.black,
  textColorError: _e.black,
  textColorDisabled: _e.white,
  borderWidth: Me(1),
  borderStyle: "solid",
  borderColor: _e.coolGray3,
  border: "".concat(Me(1), " solid ").concat(_e.coolGray3),
  borderColorDisabled: _e.coolGray3,
  linkColor: _e.black,
  linkColorHover: _e.blue,
  linkColorActive: _e.blue,
  linkDecoration: "underline",
  transitionDuration: "0.2s",
  hrPrimary: "".concat(Me(4), " solid ").concat(_e.charcoal),
  hrSecondary: "".concat(Me(1), " solid ").concat(_e.charcoal),
  hrTertiary: "".concat(Me(1), " solid ").concat(_e.coolGray3)
}),
    Ve = n.svg.withConfig({
  displayName: "Icon__StyledSVG",
  componentId: "y10cf0-0"
})(["background-color:", ";display:inline-block;", ";"], function (e) {
  return e.backgroundColor;
}, function (e) {
  return e.tabIndex < 0 && "\n    outline: none;\n    pointer-events: none;\n  ";
}),
    Re = function Re(e) {
  if ("number" == typeof e) return je(e);

  switch (e) {
    case "extraLarge":
      return je(28);

    case "large":
      return je(24);

    case "medium":
      return je(20);

    case "small":
      return je(16);

    case "extraSmall":
    default:
      return je(12);
  }
},
    Ne = function Ne(t) {
  t.ariaHidden;
  var o = t.name,
      r = t.size,
      n = t.lineColor,
      i = t.color,
      a = t.backgroundColor,
      l = t.inverted,
      c = ze[o],
      s = n || i;
  return (!l || i || n) && (!l || "black" !== i && i !== Ae.black && "Black" !== i) || (s = Ae.white), c ? e.createElement(Ve, {
    "aria-label": t.ariaLabel ? t.ariaLabel : o + " icon",
    tabIndex: t.tabIndex,
    width: Re(r),
    height: Re(r),
    viewBox: c.viewBox,
    backgroundColor: a || "transparent",
    style: t.style
  }, e.createElement("g", null, c.path.map(function (t) {
    return e.createElement("path", {
      key: t,
      fill: s,
      d: t
    });
  }), c.polygon && c.polygon.map(function (t) {
    return e.createElement("polygon", {
      key: t,
      fill: s,
      points: t
    });
  }), c.circle && c.circle.map(function (t) {
    return e.createElement("circle", {
      key: "".concat(t.cx).concat(t.cy).concat(t.r),
      fill: s,
      cx: t.cx,
      cy: t.cy,
      r: t.r
    });
  }), c.rect && c.rect.map(function (t) {
    return e.createElement("rect", {
      key: "".concat(t.x).concat(t.y),
      fill: s,
      x: t.x,
      y: t.y,
      transform: t.transform,
      width: t.width,
      height: t.height
    });
  }), c.pathOther && c.pathOther.map(function (t) {
    return e.createElement("path", {
      key: t.d,
      d: t.d,
      fill: s,
      transform: t.transform
    });
  }))) : null;
},
    Ze = {
  ariaLabel: r.string,
  name: r.string.isRequired,
  size: r.oneOfType([r.number, r.string]),
  lineColor: r.string,
  color: r.string,
  backgroundColor: r.string,
  style: r.object,
  tabIndex: r.number,
  inverted: r.bool
};

Ne.propTypes = Ze, Ne.defaultProps = {
  size: "extraSmall",
  color: "black",
  backgroundColor: "transparent",
  style: void 0,
  lineColor: void 0,
  tabIndex: 0,
  inverted: !1
};

var Ue = {
  children: r.node.isRequired,
  className: r.string,
  disabled: r.bool,
  error: r.bool,
  errorMsg: r.string,
  errorText: r.string,
  label: r.string,
  placeholder: r.string,
  width: r.string,
  size: r.oneOf(["large", "normal", "medium", "small", "desktopSmall", "mobileSmall", "desktopLarge", "mobileLarge"]),
  theme: r.object
},
    qe = {
  className: null,
  disabled: !1,
  error: !1,
  size: "normal",
  theme: se
},
    Ke = ["small", "medium", "normal", "large"],
    Ye = 146,
    Je = 156,
    Qe = n(X).withConfig({
  displayName: "DropdownSelectMarketing__DropdownErrorMsg",
  componentId: "avulwo-0"
})([""]),
    Xe = n.div.withConfig({
  displayName: "DropdownSelectMarketing__DropdownErrorWrapper",
  componentId: "avulwo-1"
})(["margin-top:", ";"], function (e) {
  return e.errorTextPadding;
}),
    $e = n.span.withConfig({
  displayName: "DropdownSelectMarketing__DropdownWrapper",
  componentId: "avulwo-2"
})(["position:relative;outline:none;"]),
    et = n.div.withConfig({
  displayName: "DropdownSelectMarketing__IconWrapper",
  componentId: "avulwo-3"
})(["display:flex;justify-content:center;outline:none;padding-left:", ";"], function (e) {
  var t = e.size;
  return Ke.includes(t) ? v(24) : v("desktopSmall" === t || "mobileSmall" === t ? 8 : 4);
}),
    tt = function (o) {
  function r() {
    var e, t;
    l(this, r);

    for (var o = arguments.length, n = new Array(o), i = 0; i < o; i++) {
      n[i] = arguments[i];
    }

    return d(h(t = b(this, (e = m(r)).call.apply(e, [this].concat(n)))), "state", {
      open: !1
    }), d(h(t), "componentDidMount", function () {
      document.addEventListener("click", t.handleClickOutside);
    }), d(h(t), "componentWillUnmount", function () {
      document.removeEventListener("click", t.handleClickOutside);
    }), d(h(t), "handleClickOutside", function (e) {
      t.triggerElem && !t.triggerElem.contains(e.target) && t.setState({
        open: !1
      });
    }), d(h(t), "toggle", function (e) {
      "click" === e.type && e.target.blur(), t.setState(function (e) {
        return {
          open: !e.open
        };
      });
    }), d(h(t), "setTriggerRef", function (e) {
      t.triggerElem = e;
    }), d(h(t), "_getIconSize", function (e) {
      switch (e) {
        case "normal":
          return 15;

        case "large":
        case "desktopLarge":
        case "mobileLarge":
          return "medium";

        case "small":
        case "medium":
        case "desktopSmall":
        case "mobileSmall":
        default:
          return "extraSmall";
      }
    }), d(h(t), "_getWidth", function (e, t) {
      if (t) return t;

      switch (e) {
        case "desktopSmall":
        case "mobileSmall":
          return v(Je);

        default:
          return v(Ye);
      }
    }), d(h(t), "_getErrorTextPadding", function (e) {
      switch (e) {
        case "desktopLarge":
        case "mobileLarge":
          return v(3);

        case "desktopSmall":
        case "mobileSmall":
          return v(1);

        default:
          return v(4);
      }
    }), t;
  }

  return u(r, t), s(r, [{
    key: "render",
    value: function value() {
      var t = this.props,
          o = t.children,
          r = t.className,
          n = t.disabled,
          i = t.error,
          a = t.errorMsg,
          l = t.errorText,
          c = t.label,
          s = t.placeholder,
          d = t.size,
          f = t.width,
          u = a || l,
          m = c || s || "",
          p = this._getIconSize(d),
          g = this._getWidth(d, f),
          h = this._getErrorTextPadding(d),
          b = i;

      return e.createElement($e, {
        tabIndex: -1,
        "aria-label": n ? "disabled dropdown-list" : ""
      }, e.createElement(we, {
        onClick: this.toggle,
        "aria-label": this.state.open ? "expanded dropdown-list" : i ? "error" : "collapsed dropdown-list current selection " + m,
        disabled: n,
        error: i,
        size: d,
        setTriggerRef: this.setTriggerRef,
        tabIndex: 0,
        width: g
      }, m, e.createElement(et, null, e.createElement(Ne, {
        tabIndex: -1,
        name: "caret-down",
        color: n ? se.grayLight : se.black,
        size: p
      }))), this.state.open && e.createElement(Fe, {
        className: r,
        error: i,
        size: d,
        triggerElem: this.triggerElem,
        tabIndex: 1
      }, o), b && u && !n && !this.state.open && e.createElement(Xe, {
        errorTextPadding: h
      }, e.createElement(Qe, null, u)));
    }
  }]), r;
}();

tt.propTypes = Ue, tt.defaultProps = qe;

var ot = {
  children: r.string,
  onSelect: r.func
},
    rt = n.option.withConfig({
  displayName: "DropdownMarketingOption__StyledOption",
  componentId: "cdc1i1-0"
})(["min-height:0;"]),
    nt = function nt(t) {
  var o = t.children,
      r = t.onSelect;
  return e.createElement(rt, {
    onKeyDown: function onKeyDown(e) {
      13 === e.keyCode && r();
    },
    onClick: r,
    "data-menu-item": !0,
    role: "menuitem",
    tabIndex: "0"
  }, o);
};

nt.defaultProps = {
  children: null,
  onSelect: function onSelect() {}
}, nt.propTypes = ot;

var it = I(),
    at = q.getStyles(it, "desktop", "medium"),
    lt = {
  disabled: r.bool,
  locked: r.bool,
  error: r.bool,
  readOnly: r.bool,
  children: r.node,
  theme: r.object,
  errorText: r.string,
  label: r.string,
  width: r.string,
  borderless: r.bool
},
    ct = {
  disabled: !1,
  locked: !1,
  error: !1,
  readOnly: !1,
  width: "136px",
  theme: se,
  borderless: !1,
  label: ""
},
    st = n.div.withConfig({
  displayName: "DropdownSelect__LabelWrapper",
  componentId: "pzad7x-0"
})(["margin-bottom:2px;> *{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;}"]),
    dt = n.div.withConfig({
  displayName: "DropdownSelect__ErrorTextWrapper",
  componentId: "pzad7x-1"
})(["margin-top:", ";"], v(4)),
    ft = n.select.withConfig({
  displayName: "DropdownSelect__SelectEl",
  componentId: "pzad7x-2"
})(["position:relative;display:inline-block;box-sizing:border-box;height:", ";width:", ";vertical-align:top;margin:0;padding:", ";background-color:", ";color:", ";line-height:", ";font-size:", ";font-family:", ";border-radius:0;border-top:", " solid ", ";border-right:", " solid ", ";border-left:", " solid ", ";border-bottom:", " solid ", ";appearance:none;", ";&:focus{outline:none;border:", " solid ", ";}&:not([multiple]){background-color:transparent;background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='12px' height='6px' viewBox='0 0 12 6' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com --%3E%3Ctitle%3EArrow down%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Dropdown-Default' transform='translate(-106.000000, -40.000000)' stroke='%23000000'%3E%3Cg transform='translate(0.000000, 8.000000)' id='Arrow-down'%3E%3Cg transform='translate(107.000000, 32.000000)'%3E%3Cpolyline id='Shape' points='0 0 5.6 5.8 11.2 0'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right ", " center;background-size:", ";padding:", ";", ";}", ";", ";", ";"], v(42), function (e) {
  return e.width;
}, v(12, 16, 8, 13.2), function (e) {
  return e.theme.secondary;
}, function (e) {
  return e.theme.primary;
}, v(at.lineHeight), v(at.fontSize), at.fontFamily, v(1), se.coolGray3, v(1), se.coolGray3, v(1), se.coolGray3, v(1), se.black, function (e) {
  var t = e.error,
      o = e.theme;
  return t && "\n    border-color: ".concat(o.error, "\n    border-bottom-width: ").concat(v(4), ";\n    padding-bottom: ").concat(v(8.2), ";\n    color: ").concat(o.black, ";\n  ");
}, v(1), function (e) {
  return e.theme.black;
}, v(16), v(12, 6), v(12, 40, 12, 16), function (e) {
  var t = e.error,
      o = e.theme;
  return t && "\n    border-color: ".concat(o.error, "\n    border-bottom-width: ").concat(v(4), ";\n    background-position: right ").concat(v(16), " center;\n    padding-bottom: ").concat(v(8.2), ";\n    background-position-y: ").concat(v(17), ";\n  ");
}, function (e) {
  var t = e.disabled,
      o = e.theme,
      r = e.readOnly;
  return t && !r && "\n    color: ".concat(o.coolGray3, ";\n    border-color: ").concat(o.disabled, ";\n    &:not([multiple]) {\n      background-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='13px' height='6px' viewBox='0 0 13 6' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com --%3E%3Ctitle%3EArrow down%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Dropdown-Default' transform='translate(-106.000000, -40.000000)' stroke='%23d8dada'%3E%3Cg transform='translate(0.000000, 8.000000)' id='Arrow-down'%3E%3Cg transform='translate(107.000000, 32.000000)'%3E%3Cpolyline id='Shape' points='0 0 5.6 5.8 11.2 0'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n    }\n  ");
}, function (e) {
  return e.readOnly && "\n    border: none;\n    &:not([multiple]) {\n      background-image: none;\n      padding-left: 0;\n    }\n  ";
}, function (e) {
  return e.borderless && "\n    border: none;\n  ";
}),
    ut = function ut(t) {
  var r = t.disabled,
      n = t.locked,
      i = t.error,
      a = t.readOnly,
      l = t.label,
      c = t.errorText,
      s = t.width,
      u = t.children,
      m = t.borderless,
      p = g(t, ["disabled", "locked", "error", "readOnly", "label", "errorText", "width", "children", "borderless"]);
  return e.createElement(o, null, l && e.createElement(st, {
    tabIndex: 0,
    "aria-label": r ? l + " disabled" : l
  }, e.createElement(X, {
    color: r ? se.coolGray3 : se.coolGray6
  }, l)), e.createElement(ft, f({}, p, d({
    borderless: m,
    width: s,
    role: "combobox",
    "aria-expanded": "false",
    "aria-owns": "combobox",
    "aria-haspopup": "listbox",
    "aria-label": i ? c : "",
    id: "combobox",
    disabled: r || n || a,
    readOnly: n || a,
    error: i
  }, "width", s)), u), i && c && e.createElement(dt, null, e.createElement(X, null, c)));
};

ut.propTypes = lt, ut.defaultProps = ct;
export { nt as DropdownMarketingOption, ut as DropdownSelect, tt as DropdownSelectMarketing };